import { render, staticRenderFns } from "./UndoRenderer.vue?vue&type=template&id=08f657e9&lang=pug&"
import script from "./UndoRenderer.vue?vue&type=script&lang=js&"
export * from "./UndoRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports